import { oneKlicks } from '../SDK/oneclick';

// Default settings structure
const defaultSettings = {
  // Branding
  site_name: 'MeddyList',
  site_description: 'Connecting patients with trusted doctors and healthcare providers. Simplifying appointments, billing, and healthcare access.',
  favicon_url: '',
  emergency_help_number: '+91 9490279973',
  emergency_help_email: 'info@meddylist.com',
  emergency_help_address: '2-19-76, Plot-169, near Community Center, Kalyanpuri, Uppal, Hyderabad, Telangana 500039',
  emergency_help_city: 'Hyderabad',
  emergency_help_state: 'Telangana',
  emergency_help_zip: '12345',
  emergency_help_country: 'India',
  emergency_help_website: 'https://www.meddylist.com',
  emergency_help_hours: '24/7',
  emergency_help_days: 'Monday to Sunday',
  emergency_help_description: 'We are here to help you with your emergency needs. Please call us at the number below.',
  emergency_help_image: '',
  emergency_help_icon: '',
  emergency_help_button_text: 'Emergency Help',

  twitter_live_feed: 'Sorry! No tweets found',

  google_plus_url: '',
  
  // Colors
  primary_color: '#007bff',
  secondary_color: '#6c757d',
  accent_color: '#28a745',
  background_color: '#ffffff',
  text_color: '#333333',
  
  // Header & Footer
  header_background: '#ffffff',
  footer_background: '#f8f9fa',
  header_text_color: '#333333',
  footer_text_color: '#666666',
  
  // Buttons
  button_primary_color: '#007bff',
  button_secondary_color: '#6c757d',
  button_text_color: '#ffffff',
  
  // Forms
  form_background: '#ffffff',
  form_border_color: '#ced4da',
  form_focus_color: '#007bff',
  
  // Social Media
  facebook_url: '',
  twitter_url: '',
  instagram_url: '',
  linkedin_url: '',
  youtube_url: '',
  rss_url: '',

  site_logo: '',
  site_logo_url: '',
  site_favicon: '',
  site_favicon_url: '',
  site_footer_logo: '',
  site_footer_logo_url: '',
  site_author_signature: '',
  site_author_signature_url: '',
  
  dark_logo_url: '',
  logo_url: '',
  small_logo_url: '',
  

  // Contact Information
  contact_email: 'info@meddylist.com',
  contact_phone: '+91 9490279973',
  contact_address: '2-19-76, Plot-169, near Community Center, Kalyanpuri, Uppal, Hyderabad, Telangana 500039',
  
  // SEO
  meta_title: 'MeddyList',
  meta_description: 'Your trusted healthcare platform',
  meta_keywords: 'MeddyList, healthcare, platform',
  
  // Features
  enable_registration: true,
  enable_appointments: true,
  enable_reviews: true,
  enable_chat: true,
  
  // Payment
  currency: 'INR',
  payment_gateway: 'stripe',
  
  // Email
  smtp_host: 'smtp.gmail.com',
  smtp_port: '587',
  smtp_username: 'info@meddylist.com',
  smtp_password: 'Meddylist@123',
  smtp_encryption: 'tls',
  
  // Analytics
  google_analytics_id: 'G-1234567890',
  facebook_pixel_id: '1234567890',
  
  // Custom CSS/JS
  custom_css: '/* Custom CSS */',
  custom_js: '/* Custom JS */',
  
  // Maintenance
  maintenance_mode: false,
  maintenance_message: 'Site is under maintenance. Please check back later.',
  
  // Security
  max_login_attempts: 5,
  session_timeout: 3600,
  
  // File Upload
  max_file_size: 5242880, // 5MB
  allowed_file_types: 'jpg,jpeg,png,gif,pdf,doc,docx',
  
  // Notifications
  email_notifications: true,
  sms_notifications: false,
  push_notifications: true
};

export const getSettings = async () => {
  try {
    console.log('Fetching settings from database...');
    const tableSchema = "";
    const tableName = "site_settings"; // ✅ CORRECT TABLE NAME
    const conditions = {};
    const orderBy = "id ASC";
    const search = {};
    const pagination = {};
    const margedata = [];

    console.log('Reading from table:', tableName);
    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    console.log('Settings response:', response);
    
    if (response.success && response.data && response.data.length > 0) {
      // Convert array of settings to object
      const settingsObject = {};
      response.data.forEach(setting => {
        // ✅ CORRECT COLUMN NAMES
        const key = setting.setting_key_name; // Handle both column names
        let value = setting.value === "" ? defaultSettings[key] : setting.value;
        
        // Parse JSON values
        if (setting.value_type === 'json') {
          try {
            value = JSON.parse(value);
          } catch (e) {
            // Keep original value if parsing fails
          }
        }
        // Parse boolean values
        else if (setting.value_type === 'boolean') {
          value = value === 'true' || value === '1';
        }
        // Parse number values
        else if (setting.value_type === 'number') {
          value = parseFloat(value) || 0;
        }
        
        if (key) {
          settingsObject[key] = value;
        }
      });
      
      console.log('Parsed settings:', settingsObject);
      // Merge with defaults for missing settings
      return { ...defaultSettings, ...settingsObject };
    }
    
    console.log('No settings found, returning defaults');
    // If no settings found, return defaults
    return defaultSettings;
  } catch (error) {
    console.error('Error fetching settings:', error);
    return defaultSettings;
  }
};

export const updateSetting = async (key, value, valueType = 'string') => {
  try {
    console.log(`Updating setting: ${key} = ${value} (${valueType})`);
    const tableSchema = "";
    const tableName = "site_settings";
    
    // Prepare value based on type
    let stringValue = value;
    if (valueType === 'json') {
      stringValue = JSON.stringify(value);
    } else if (valueType === 'boolean') {
      stringValue = value ? 'true' : 'false';
    } else if (valueType === 'number') {
      stringValue = value.toString();
    }
    
    // Check if the setting exists first to determine if we should update or create
    const readResponse = await oneKlicks.read(tableSchema, tableName, { setting_key_name: key }, "", "", "", "");
    const exists = readResponse.success && readResponse.data && readResponse.data.length > 0;

    const data = {
      setting_key_name: key,
      value: stringValue,
      value_type: valueType
    };

    if (exists) {
      console.log('Setting exists, updating...');
      const updateResponse = await oneKlicks.update(tableSchema, tableName, data, { setting_key_name: key });
      return updateResponse.success;
    } else {
      console.log('Setting does not exist, creating...');
      const createResponse = await oneKlicks.create(tableSchema, tableName, data, {});
      return createResponse.success;
    }
  } catch (error) {
    console.error('Error updating setting:', error);
    return false;
  }
};

export const updateMultipleSettings = async (settings) => {
  try {
    console.log('Updating multiple settings:', settings);
    const promises = Object.entries(settings).map(([key, value]) => {
      let valueType = 'string';
      if (typeof value === 'boolean') valueType = 'boolean';
      else if (typeof value === 'number') valueType = 'number';
      else if (typeof value === 'object') valueType = 'json';
      
      return updateSetting(key, value, valueType);
    });
    
    const results = await Promise.all(promises);
    console.log('Multiple settings update results:', results);
    return results.every(result => result === true);
  } catch (error) {
    console.error('Error updating multiple settings:', error);
    return false;
  }
};

export const resetSettingsToDefault = async () => {
  try {
    console.log('Resetting settings to default...');
    const promises = Object.entries(defaultSettings).map(([key, value]) => {
      let valueType = 'string';
      if (typeof value === 'boolean') valueType = 'boolean';
      else if (typeof value === 'number') valueType = 'number';
      else if (typeof value === 'object') valueType = 'json';
      
      return updateSetting(key, value, valueType);
    });
    
    const results = await Promise.all(promises);
    console.log('Reset results:', results);
    return results.every(result => result === true);
  } catch (error) {
    console.error('Error resetting settings:', error);
    return false;
  }
};

export const exportSettings = async () => {
  try {
    const settings = await getSettings();
    const dataStr = JSON.stringify(settings, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(dataBlob);
    link.download = 'meddylist-settings.json';
    link.click();
    
    return true;
  } catch (error) {
    console.error('Error exporting settings:', error);
    return false;
  }
};

export const importSettings = async (file) => {
  try {
    const text = await file.text();
    const settings = JSON.parse(text);
    
    // Validate settings structure
    const validSettings = {};
    Object.keys(defaultSettings).forEach(key => {
      if (settings.hasOwnProperty(key)) {
        validSettings[key] = settings[key];
      }
    });
    
    return await updateMultipleSettings(validSettings);
  } catch (error) {
    console.error('Error importing settings:', error);
    return false;
  }
};

// Initialize database with default settings if table is empty
export const initializeDatabase = async () => {
  try {
    console.log('Initializing database with default settings...');
    
    // Check if we have any settings in database
    const tableSchema = "";
    const tableName = "site_settings"; // ✅ CORRECT TABLE NAME
    
    const response = await oneKlicks.read(tableSchema, tableName, {}, "id ASC", {}, {}, []);
    console.log('Current settings table response:', response);
    
    if (!response.success) {
      console.error('Failed to read settings from database');
      return false;
    }

    const existingSettings = {};
    if (response.data && response.data.length > 0) {
      response.data.forEach(setting => {
        const key = setting.setting_key_name || setting.setting_key || setting.key;
        if (key) {
          existingSettings[key] = true;
        }
      });
    }

    // Find settings that are in defaultSettings but not in database
    const missingSettings = {};
    let hasMissing = false;

    Object.entries(defaultSettings).forEach(([key, value]) => {
      if (!existingSettings[key]) {
        missingSettings[key] = value;
        hasMissing = true;
      }
    });

    if (hasMissing) {
      console.log('Missing settings found, creating them...', Object.keys(missingSettings));
      // Only update the missing ones to avoid overwriting user changes with defaults
      return await updateMultipleSettings(missingSettings);
    }
    
    console.log('Database already has all required settings, skipping initialization');
    return true;
  } catch (error) {
    console.error('Error initializing database:', error);
    return false;
  }
};
